import React from "react";

// Libraries & Packages
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

// Utils
import { RICH_TEXT_OPTIONS } from "./ArticleUtils";

function Article({ article }) {
  return <div> {documentToReactComponents(article, RICH_TEXT_OPTIONS)}</div>;
}

export default Article;
